import styled from 'styled-components';
import {
  borderRadius,
  buttonStyle,
  space,
  fontSize,
  fontWeight,
  lineHeight,
  flexbox,
  width,
  background,
  variant
} from 'styled-system';

import { colors } from '@styles/theme';

export function errorStyles() {
  const styles = {};
  styles.boxShadow = 'none';
  styles.cursor = 'auto';
  styles.color = colors.darkGray;
  styles.backgroundColor = colors.red;
  return styles;
}

export function disabledStyles() {
  const styles = {};
  styles.boxShadow = 'none';
  styles.cursor = 'auto';
  styles.color = colors.darkGray;
  styles.backgroundColor = colors.white;
  return styles;
}

export function activeStyles(props) {
  if (props.disabled) {
    return disabledStyles(props);
  }

  const styles = {};

  styles.backgroundColor = colors.lightGray;
  styles.color = colors.primary;
  styles.boxShadow = 'none';
  styles.cursor = 'pointer';

  return styles;
}

export function defaultStyles(props) {
  if (props.hasError) {
    return errorStyles(props);
  }

  if (props.selected) {
    return activeStyles(props);
  }

  if (props.disabled) {
    return disabledStyles(props);
  }

  if (props.isToday) {
    return activeStyles(props);
  }

  const styles = {};
  styles.color = colors.primary;
  styles.boxShadow = 'none';
  styles.cursor = 'pointer';
  styles.backgroundColor = colors.white;
  return styles;
}

const buttonSize = variant({
  prop: 'size',
  key: 'cfButtonSizes'
});

const BaseHalfCalendarButton = styled('button')`
  display: flex;
  flex-direction: column;

  border: 0;
  border-right: 1px solid rgb(216, 216, 216);

  &:last-child {
    border-right: 0;
  }

  &:enabled {
    ${props => defaultStyles(props)}
  }

  &:disabled {
    ${props => disabledStyles(props)}
  }

  &:focus {
    outline: none;
  }

  ${borderRadius}
  ${buttonStyle}
  ${space}
  ${width}  
  ${fontSize}
  ${fontWeight}
  ${lineHeight}
  ${flexbox}
  ${background}
  ${buttonSize}
`;

BaseHalfCalendarButton.defaultProps = {
  borderRadius: 0,
  fontSize: 2,
  lineHeight: 1.29,
  fontWeight: 'normal',
  size: ['small', 'medium', 'large']
};

export default BaseHalfCalendarButton;
